module.exports = __webpack_public_path__ + "static/media/cn.a440d38c.svg";